"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Not all your dates are available in the calendar.");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Maybe you meant to choose Saturday rather than Sunday as your starting day or only have a single day competition?");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Try reducing the number of days which are spanned by your competition");
class DateError extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, (0, _occasion.default)(this.props.calendarDateID, 'dddd') === 'Sunday' ? _ref2 : _ref3);
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = DateError;